module.exports = __webpack_public_path__ + "img/iphone8screenshot2.2386428e.png";